<app-nav></app-nav>

<div class="padding-2" fxLayout="column" *ngIf="member">
    <h1 class="_h1">{{member.firstName}} {{member.lastName}}</h1>

    <app-listings-by-member [memberId]="member.memberId"></app-listings-by-member>
</div>
